import { getFormatMessage } from '@/utils/utils'
import { Tabs } from 'antd'
import React from 'react'
import { TemplateAlarm } from '../alarm'
import { TemplateTabProps } from '../interface'
import { TemplateMacro } from '../macros'
import { TemplatePlc } from '../plc'
import { TemplateTransfer } from '../transfer'
import { TemplateVariable } from '../variable'

const { TabPane } = Tabs

export const TemplateTab: React.FC<TemplateTabProps> = (
  props: TemplateTabProps
) => {
  const formatMessage = getFormatMessage()

  return (
    <div>
      <Tabs>
        <TabPane
          key='app.template.tab.plcs'
          tab={formatMessage({ id: 'app.template.tab.plcs' })}
        >
          <TemplatePlc
            data={props.plcs}
            pagination={props.plcPagination}
            onFormSubmit={props.onPlcCreate}
            onDelete={props.onPlcDelete}
            onSearch={props.onPlcSearch}
            onRefCheck={props.onPlcRefCheck}
            onRefRelease={props.onPlcRefRelease}
          />
        </TabPane>
        <TabPane
          key='app.template.tab.variables'
          tab={formatMessage({ id: 'app.template.tab.variables' })}
        >
          <TemplateVariable
            data={props.variables}
            plcs={props.plcs}
            pagination={props.variablePagination}
            onFormSubmit={props.onVariableCreate}
            onDelete={props.onVariableDelete}
            onSearch={props.onVariableSearch}
            onRefCheck={props.onVariableRefCheck}
            onRefRelease={props.onVariableRefRelease}
          />
        </TabPane>
        <TabPane
          key='app.template.tab.alarm'
          tab={formatMessage({ id: 'app.template.tab.alarm' })}
        >
          <TemplateAlarm
            data={props.alarms}
            plcs={props.plcs}
            variables={props.variables?.filter((x) => x.dataType !== 30)}
            pagination={props.alarmPagination}
            onFormSubmit={props.onAlarmCreate}
            onDelete={props.onAlarmDelete}
            onSearch={props.onAlarmSearch}
            onRefCheck={props.onAlarmRefCheck}
            onRefRelease={props.onAlarmRefRelease}
          />
        </TabPane>
        <TabPane
          key='app.template.tab.macro'
          tab={formatMessage({ id: 'app.template.tab.macro' })}
        >
          <TemplateMacro
            {...props.macroDebugger}
            data={props.macros}
            plcs={props.plcs}
            variables={props.variables}
            onDelete={props.onMacroDelete}
            onSearch={props.onMacroSearch}
            onSave={props.onMacroCreate}
          />
        </TabPane>
        <TabPane
          key='app.template.tab.transfers'
          tab={formatMessage({ id: 'app.template.tab.transfers' })}
        >
          <TemplateTransfer
            {...props}
            data={props.transfers}
            variables={props.variables}
            alarms={props.alarms}
            onFormSubmit={props.onTransferCreate}
            onDelete={props.onTransferDelete}
            onChange={props.onTransferChange}
          />
        </TabPane>
      </Tabs>
    </div>
  )
}
